<div class="row">
  <div class="col-sm-12 col-lg-12 col-md-12 paddingZero">
    <kendo-panelbar (expand)="onPanelBarSelect($event)" #panelbar>
      <kendo-panelbar-item id="mechSchInfo" title="{{mechanicsSchoolTxt.mechnicsSchoolInformationLbl?mechanicsSchoolTxt.mechnicsSchoolInformationLbl:mechanicsSchool.mechnicsSchoolInformationLbl}}"
                           [expanded]="true" >
        <ng-template kendoPanelBarContent>
          <div class="row m-top left">
            <div class="col-sm-12">
              <kendo-tabstrip [scrollable]="true" [tabPosition]="position" (tabSelect)="onTabSelected($event)" class="k-tabstrip">
                <kendo-tabstrip-tab title="{{mechanicsSchool.currentYear}} {{mechanicsSchoolTxt.mechnicsSchoolLbl?mechanicsSchoolTxt.mechnicsSchoolLbl:mechanicsSchool.mechnicsSchoolLbl}}" [selected]="true">
                  <ng-template kendoTabContent>
                    <!--<p>{{mechanicsSchoolData?.schoolDescription}}</p>-->
                    <p [innerHTML]="mechanicsSchoolData?.schoolDescription"></p>
                    <div class="myIframe" *ngIf="schoolDescriptionPdfUrl">
                      <iframe [src]="secureUrl"
                              type="application/pdf"></iframe>
                    </div>
                  </ng-template>
                </kendo-tabstrip-tab>

                <kendo-tabstrip-tab title="{{mechanicsSchoolTxt.locationInformationLbl?mechanicsSchoolTxt.locationInformationLbl:mechanicsSchool.locationInformationLbl}}">
                  <ng-template kendoTabContent>
                    <div *ngFor="let list of mechanicsSchoolData?.mechanicsSchoolLocationDetails">
                      <h6>{{list.locationName}}</h6>
                      <div>
                        <p>{{list.locationDescription}}</p>
                        <p>{{list.startDate}} - {{list.endDate}} </p>
                        <p>{{mechanicsSchoolTxt.priceLbl?mechanicsSchoolTxt.priceLbl:mechanicsSchool.priceLbl}} : {{list.price}}</p>
                        <p>{{mechanicsSchoolTxt.seatsLbl?mechanicsSchoolTxt.seatsLbl:mechanicsSchool.seatsLbl}} : {{list.totalSeats}}</p>
                        <p>{{mechanicsSchoolTxt.remainingSeatsLbl?mechanicsSchoolTxt.remainingSeatsLbl:mechanicsSchool.remainingSeatsLbl}} : {{list.remainingSeats< 0 ?  0 : list.remainingSeats}}</p>
                        
                      </div>
                    </div>
                  </ng-template>
                </kendo-tabstrip-tab>

                <!--
                 <kendo-tabstrip-tab title="{{mechanicsSchoolTxt.registrationLbl?mechanicsSchoolTxt.registrationLbl:mechanicsSchool.registrationLbl}}">
                  <ng-template kendoTabContent>
                   <p>{{mechanicsSchoolData?.registrationDescription}}</p>
                      <p [innerHTML]="mechanicsSchoolData?.registrationDescription"></p>
                      <div class="myIframe" *ngIf="registrationDescriptionPdfUrl">
                         <iframe [src]="registrationDescriptionPdfUrl"
                           type="application/pdf"></iframe>
                         </div>
                  </ng-template>
                </kendo-tabstrip-tab>-->
                <kendo-tabstrip-tab title="{{mechanicsSchoolTxt.liabilityWaiverLbl?mechanicsSchoolTxt.liabilityWaiverLbl:mechanicsSchool.liabilityWaiverLbl}}">
                  <ng-template kendoTabContent>
                    <div class="col-sm-12">
                      <span class="k-icon k-i-file-pdf"></span> <a href="javascript:void(0)" (click)="openDocument(pdfUrl)">{{mechanicsSchoolTxt.pdfLinkLbl?mechanicsSchoolTxt.pdfLinkLbl:mechanicsSchool.pdfLinkLbl}}</a>
                    </div>
                  </ng-template>
                </kendo-tabstrip-tab>
              </kendo-tabstrip>
</div>
          </div>
          <div class="d-flex justify-content-center col-xs-12 col-sm-12">
            <button kendoButton primary="true" class="continue-button m-3"
                    (click)="continueToNextPanel()">
              {{mechanicsSchoolTxt.continueLbl?mechanicsSchoolTxt.continueLbl:mechanicsSchool.continueLbl}}
            </button>
          </div>
        </ng-template>
      </kendo-panelbar-item>
      <kendo-panelbar-item id="onlineReg" title="{{mechanicsSchoolTxt.onlineRegistrationLbl?mechanicsSchoolTxt.onlineRegistrationLbl:mechanicsSchool.onlineRegistrationLbl}}"
                           [expanded]="false">
        <ng-template kendoPanelBarContent>
          <div class="row m-top">
            <div class="col-sm-0 col-md-0 col-lg-1"></div>
            <div class="col-sm-12 col-md-12 col-lg-10 paddingZero">
              <form [formGroup]="registrationForm">
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="lbl">{{mechanicsSchoolTxt.firstNameLbl?mechanicsSchoolTxt.firstNameLbl:mechanicsSchool.firstNameLbl}}<span class="requiredField">*</span></label>
                      <input type="text" kendoTextBox formControlName="firstName"
                             class="kendoInput" [ngClass]="{'borderRed':mechanicsSchool.isEmptyFirstName && mechanicsSchool.isSubmitted}"
                     (blur)="validateMechanicsSchoolForm()" />
                    </div>
                    <div class="form-group">
                      <label class="lbl">{{mechanicsSchoolTxt.lastNameLbl?mechanicsSchoolTxt.lastNameLbl:mechanicsSchool.lastNameLbl}}</label>
                      <input type="text" kendoTextBox formControlName="lastName"
                             class="kendoInput" />
                    </div>
                    <div class="form-group">
                      <label class="lbl">{{mechanicsSchoolTxt.jobTitleLbl?mechanicsSchoolTxt.jobTitleLbl:mechanicsSchool.jobTitleLbl}}<span class="requiredField">*</span></label>
                      <input type="text" kendoTextBox formControlName="jobTitle"
                             class="kendoInput" [ngClass]="{'borderRed':mechanicsSchool.isEmptyJobTitle && mechanicsSchool.isSubmitted}"
                     (blur)="validateMechanicsSchoolForm()" />
                    </div>
                    <div class="form-group">
                      <label class="lbl">{{mechanicsSchoolTxt.companyNameLbl?mechanicsSchoolTxt.companyNameLbl:mechanicsSchool.companyNameLbl}}<span class="requiredField">*</span></label>
                      <input type="text" kendoTextBox formControlName="companyName"
                             class="kendoInput" [ngClass]="{'borderRed':mechanicsSchool.isEmptyCompanyName && mechanicsSchool.isSubmitted}"
                     (blur)="validateMechanicsSchoolForm()" />
                    </div>
                    <div class="form-group">
                      <label class="lbl">{{mechanicsSchoolTxt.addressLbl?mechanicsSchoolTxt.addressLbl:mechanicsSchool.addressLbl}}</label>
                      <input type="text" kendoTextBox formControlName="address"
                             class="kendoInput" />
                    </div>
                    <div class="form-group">
                      <label class="lbl">{{mechanicsSchoolTxt.cityLbl?mechanicsSchoolTxt.cityLbl:mechanicsSchool.cityLbl}}&nbsp;&nbsp;</label>
                      <input type="text" kendoTextBox formControlName="city"
                             class="kendoInput" />
                    </div>
                    <div class="form-group">
                      <label class="lbl">{{mechanicsSchoolTxt.commentLbl?mechanicsSchoolTxt.commentLbl:mechanicsSchool.commentLbl}}</label>
                      <textarea kendoTextArea class="kendoInput"
                                formControlName="comments"></textarea>
                    </div>
                    <h6>{{mechanicsSchoolTxt.selectSeminarLbl?mechanicsSchoolTxt.selectSeminarLbl:mechanicsSchool.selectSeminarLbl}}:</h6>

                    <div class="form-group" *ngFor="let list of mechanicsSchoolData?.mechanicsSchoolLocationDetails">
                      <kendo-switch name="selectSeminar" class="switch-control" [onLabel]="'Yes'" [offLabel]="'No'" (click)="seminarCheck(list)">
                      </kendo-switch>
                      <label class="switch-label" [for]="selectSeminar"><b>{{list.locationName}}</b><br />{{list.locationDescription}}<br />{{list.startDate}} - {{list.endDate}}<br />Price: {{list.price}} <br />Total Seats: {{list.totalSeats}}<br />Available Seats: {{list.remainingSeats< 0 ?  0 : list.remainingSeats }}</label>
                      <span title="{{mechanicsSchoolTxt.invalidLocation?mechanicsSchoolTxt.invalidLocation:mechanicsSchool.invalidLocation}}" *ngIf="mechanicsSchool.isInvalidLocation" kendoTooltip
                            class="k-icon k-i-information k-i-info spanInfoIconCls"></span>
                    </div>

                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="lbl">{{mechanicsSchoolTxt.emailLbl?mechanicsSchoolTxt.emailLbl:mechanicsSchool.emailLbl}}<span class="requiredField">*</span></label>
                      <input type="text" kendoTextBox formControlName="email"
                             class="kendoInput" [ngClass]="{'borderRed':(mechanicsSchool.isEmptyEmail || mechanicsSchool.isInvalidEmail) && mechanicsSchool.isSubmitted}"
                             (blur)="emailLeave()" />
                      <span title="{{mechanicsSchoolTxt.invalidEmail?mechanicsSchoolTxt.invalidEmail:mechanicsSchool.invalidEmail}}" *ngIf="mechanicsSchool.isInvalidEmail" kendoTooltip
                            class="k-icon k-i-information k-i-info spanInfoIconCls"></span>
                    </div>

                    <div class="form-group">
                      <label class="lbl">{{mechanicsSchoolTxt.phoneNumber?mechanicsSchoolTxt.phoneNumber:mechanicsSchool.phoneNumber}}<span class="requiredField">*</span></label>
                      <kendo-numerictextbox formControlName="phoneNumber" [maxlength]="10"
                                            [format]="'#'" [spinners]="false"
                                            class="kendoInput" [ngClass]="{'borderRed':mechanicsSchool.isEmptyPhoneNumber && mechanicsSchool.isSubmitted}"
                                    (blur)="validateMechanicsSchoolForm()"></kendo-numerictextbox>
                      <span title="{{mechanicsSchoolTxt.invalidPhoneLbl?mechanicsSchoolTxt.invalidPhoneLbl:mechanicsSchool.invalidPhoneLbl}}"
                      *ngIf="mechanicsSchool.isInvalidPhoneNumber" kendoTooltip
                      class="k-icon k-i-information k-i-info spanInfoIconCls"></span>
                    </div>
                    <div class="form-group">
                      <label class="lbl">{{mechanicsSchoolTxt.faxNumberLbl?mechanicsSchoolTxt.faxNumberLbl:mechanicsSchool.faxNumberLbl}}</label>
                      <input type="text" kendoTextBox formControlName="faxNumber"
                             class="kendoInput" />
                    </div>
                    <div class="form-group">
                      <label class="lbl">{{mechanicsSchoolTxt.countryLbl?mechanicsSchoolTxt.countryLbl:mechanicsSchool.countryLbl}}</label>
                      <kendo-dropdownlist [data]="countries" kendoTextBox class="kendoInput" [textField]="'countryName'"
                                          [valueField]="'countryCode'" name="country" formControlName="country"
                                          (selectionChange)="countySelectionChange($event)"
                                          [valuePrimitive]="true">
                      </kendo-dropdownlist>
                    </div>

                    <div class="form-group">
                      <label class="lbl">{{mechanicsSchoolTxt.stateLbl?mechanicsSchoolTxt.stateLbl:mechanicsSchool.stateLbl}}</label>
                      <kendo-dropdownlist class="kendoInput"
                                          formControlName="state"
                                          [ngModel]="{stateDescription:selectedState,stateCode:selectedState}"
                                          [data]="states"
                                          [textField]="'stateDescription'"
                                          [valueField]="'stateCode'">
                      </kendo-dropdownlist>
                    </div>
                    <div class="form-group">
                      <label class="lbl">{{mechanicsSchoolTxt.zipCodeLbl?mechanicsSchoolTxt.zipCodeLbl:mechanicsSchool.zipCodeLbl}}</label>
                      <input type="text" kendoTextBox formControlName="zipCode"
                             class="kendoInput" maxlength="10" />
                    </div>
                  </div>
                  <!--<div class="col-sm-12">
                    <p>{{mechanicsSchoolTxt.infoLbl?mechanicsSchoolTxt.infoLbl:mechanicsSchool.infoLbl}}</p>
                  </div>-->
                </div>
              </form>
              <div class="d-flex justify-content-center col-xs-12 col-sm-12">
                <button kendoButton
                        (click)="resetForm()" [disabled]="saveInProcess" class="m-3" primary="true">
                  {{mechanicsSchoolTxt.cancelLbl?mechanicsSchoolTxt.cancelLbl:mechanicsSchool.cancelLbl}}
                </button>
                <button kendoButton
                        (click)="submit()" [disabled]="saveInProcess" class="m-3" primary="true">
                  {{mechanicsSchoolTxt.submitLbl?mechanicsSchoolTxt.submitLbl:mechanicsSchool.submitLbl}}<kendo-loader *ngIf="saveInProcess" style="color:blue"></kendo-loader>
                </button>
              </div>
            </div>
            <div class="col-sm-0 col-md-0 col-lg-1"></div>

          </div>

        </ng-template>
      </kendo-panelbar-item>

    </kendo-panelbar>
  </div>

</div>
